
import makerjs from "makerjs";
function B48(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,S1 = Param[2].param,
    // T = Param[3].param,S1 = Param[4].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,
       b = B * 1 * myZoom,       
       l = L * 1 * myZoom,       
       s1 = S1 * 1 * myZoom,       
       h = l,
       w = b,
       //hd=r-l,
       rd=s1/Math.sqrt(2),
          rMark=s1-rd,
       x0 = 0, x1 = 0, x2 =s1 ,x3 =b-s1 ,x4 =b,x5=b,x6=b-s1,x7=s1, 
       y0 = s1, y1 =l-s1,y2 =l, y3 =l,y4=l-s1,y5=s1,y6=0,y7=0,glassH =l, glassW = w;
       if (b !== 0) {
        var TxtB ="B="+ B;
    }  if (l !== 0) {
     var TxtL = "L="+L;
   }    if (s1 !== 0) {
     var TxtS1 = "S1="+S1;
   }
   var drawAbnormalShapeB48 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "LeftArcLine": new makerjs.paths.Arc([x1, y1], [x2,y2], s1,false,true),
        "TopLine": new makerjs.paths.Line([x2,y2], [x3,y3]),
        "RightArcLine": new makerjs.paths.Arc([x3,y3], [x4,y4], s1,false,true),
        "RightLine": new makerjs.paths.Line([x4,y4], [x5,y5]),
        "RightBottomArcLine": new makerjs.paths.Arc([x5,y5], [x6,y6], s1,false,true),
        "BottomLine": new makerjs.paths.Line([x6,y6],[x7,y7]),
        "LeftBottomArcLine": new makerjs.paths.Arc([x7,y7], [x0,y0], s1,false,true),
       }
   };
   var drawAbnormalShapeB48MarkB = {
       paths: {
        "bottomLine": new makerjs.paths.Line([0, -markShift], [b, -markShift]),        
        "RightShortUpline": new makerjs.paths.Line([0, 0], [0, -3*markShift]),
        "RightShortDnline": new makerjs.paths.Line([b, 0], [b, -3*markShift]),
       }  
   };
   var drawAbnormalShapeB48MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y7], [x1- markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x0, y7], [x0- 2 * markShift, y7]),
        "RightShortDnline": new makerjs.paths.Line([x1, y2], [x1- 2 * markShift, y2]),
       }
   };
   var drawAbnormalShapeB48MarkS1 = {
       paths: {
        "Line": new makerjs.paths.Line([rMark, l-rMark], [s1, l-s1]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeB48MarkB, TxtB,  [0,-2*markShift], [b, -2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB48MarkL, TxtL,  [x0- 2*markShift, y0], [x1- 2*markShift, y2]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB48MarkS1, TxtS1,  [s1+markShift, l-s1-2*markShift], [s1+3*markShift, l-s1-2*markShift]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB48: drawAbnormalShapeB48,
      }
    };
  markers={
      models: {
        drawAbnormalShapeB48: drawAbnormalShapeB48,
        drawAbnormalShapeB48MarkB:drawAbnormalShapeB48MarkB,
        drawAbnormalShapeB48MarkL:drawAbnormalShapeB48MarkL,
        drawAbnormalShapeB48MarkS1:drawAbnormalShapeB48MarkS1,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B48;